import { createContext, useContext, useState } from 'react';
import bn from '../locales/bn';
import en from '../locales/en';

const LanguageContext = createContext(null);

const languages = { bn, en };

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('language') || 'bn';
  });

  const t = (key) => {
    return languages[lang]?.[key] || key;
  };

  const toggleLanguage = () => {
    const newLang = lang === 'bn' ? 'en' : 'bn';
    setLang(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
